import styled, { css } from 'styled-components';


export const Image = styled.img`
  width: ${({ width = 25 }) => `${width}px`};
  height: ${({ height = 25 }) => `${height}px`};
  object-fit: cover;
  border-radius: 50%;
  ${({ showBorder, borderWidth }: { showBorder: boolean, borderWidth: number }) => showBorder && css`
    border: ${borderWidth}px solid ${ props => props.theme.colors.fallow };  
  `}
  margin-bottom: 10px;

  @media (max-width: ${(props) => props.theme.mediaQueryConstants.phone}px) {
    margin-bottom: 4px;
  }; 
`;

export const StyledTabTitle = styled.div`
  font-size: 12px;
  font-weight: 600;
  margin-bottom: 7px;
`;

export const TabContent = styled.div<{isLastItem}>`
  margin-bottom:${(props) => props.isLastItem ? '0' : '80px'};
  display: inline-grid;
	grid-template-columns: 100%;
  width: 100%;
	column-gap: 25px;
  row-gap: 20px;
`;

export const MaterialWrapper = styled.div`  
  display: inline-grid;
	grid-template-columns: calc(100%/2 - 25px/2) calc(100%/2 - 25px/2);
  width: 100%;
	column-gap: 25px;
  row-gap: 20px;
`;

export const MenuSection = styled.div`
  &.threed-configurator-menu-section-materials-finish {
    margin-top: 1.5em;
      
    @media (max-width: ${(props) => props.theme.mediaQueryConstants.phone}px) {
      margin-top: 4px;
    };
  }
`;

export const SectionTitle = styled.div`
  margin-left: 20px;

  @media (max-width: ${(props) => props.theme.mediaQueryConstants.phone}px) {
    margin-bottom: 5px;
  };  
  
  @media (max-width: ${(props) => props.theme.mediaQueryConstants.phoneTiny}px) {
    margin-left: 5px;
  };
`;

export const OptionsContainer = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
`

export const OptionItem = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;

  font-weight: 500;
  font-size: 11px;
  line-height: 13px;
  text-align: center;
  letter-spacing: 0.03em;

  padding: 10px 5px;

  width: 25%;

  cursor: pointer; 

  @media (max-width: ${(props) => props.theme.mediaQueryConstants.phone}px) {
    width: 16.6%;
    
    padding-top: 0px;
    padding-left: 5px;
    padding-right: 5px;
    padding-bottom: 5px;

    font-size: 10px;
	}
`;

export const RadioGroupWrapper = styled.div`
  width: 100%;
  margin-bottom: 15px;
`;
